import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./page/Home";
import { useSnackbar, SnackbarProvider } from "notistack";

import Admin from "./components/AdminPanel"
import VehicleDetails from "./page/Details"; // adjust path as needed

import TelegramIcon from "./components/TelegramIcon"; // Adjust the path as necessary
import Top from "./components/TopNav";
import CarLoan from "./components/CarLoan";
import Sell from "./components/SellRequest";

import Navigation from "./components/Navigation";
import Footer from "./components/Footer";




const App: React.FC = () => {
  return (
    <>
      <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
  >
    <Top/>
      <Navigation />
      <div className="layout-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pre-approval" element={<CarLoan />} />
          <Route path="/sell-your-car" element={<Sell />} />

          {/* <Route path="terms-of-use" element={<Privacy />} />
          <Route path="privacy-policy" element={<Cookie />} />
          <Route path="about" element={<PrivacyPolicy />} />
          <Route path="understanding-car-loans" element={<Loan />} />
          <Route path="calculator" element={<Calculator />} /> */}
          {/* <Route path="/admin" element={<Admin />} /> */}

          <Route path="/vehicle/:id" element={<VehicleDetails />} />


        </Routes>
      </div>
      <Footer />
      {/* <TelegramIcon/> */}
      </SnackbarProvider>
    </>
  );
};

export default App;
